export enum ApprovalProcessStatus {
  REQUEST_CREATED = 'REQUEST_CREATED',
  PUBLISH_REQUESTED = 'PUBLISH_REQUESTED',
  PUBLISH_APPROVED = 'PUBLISH_APPROVED',
  PENDING_PUBLICATION = 'PENDING_PUBLICATION',
  PUBLISH_REJECTED = 'PUBLISH_REJECTED',
}
